/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IDivisionesTiposPropiedades from 'Infotrack@Modelos/smartStock/divisionesTiposPropiedades/entidades/divisionesTiposPropiedades';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import DivisionesTiposPropiedadesCM from '../controladorModelo/divisionesTiposPropiedadesCM';
import { acciones, IEstadoDivisionesTiposPropiedades } from '../reductorDivisionesTiposPropiedades';
import DivisionesTiposPropiedadesVista from '../vista/tablaDivisionesTiposPropiedadesVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import { useSelector } from 'react-redux';

const divisionesTiposPropiedadesCM = new DivisionesTiposPropiedadesCM();

const TableDivisionesTiposPropiedadesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [divisionesTiposPropiedadess, setDivisionesTiposPropiedadess] = React.useState<IDivisionesTiposPropiedades[]>(
        []
    );
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoDivisionesTiposPropiedades>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarDivisionesTiposPropiedades();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarDivisionesTiposPropiedades = () => {
        manejadorIndicadorCargaGlobal(true);
        divisionesTiposPropiedadesCM.consultarDivisionesTiposPropiedadesPorFiltro({EmpresaId:idEmpresa}).then((divisionesTiposPropiedadess) => {
            setDivisionesTiposPropiedadess(divisionesTiposPropiedadess);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (
        tipoFormulario: TipoFormulario,
        entidadDivisionesTiposPropiedades?: IDivisionesTiposPropiedades
    ) => {
        dispatch({
            type: acciones.CAMBIAR_ESTADO_FORMULARIO,
            payload: { entidadDivisionesTiposPropiedades, tipoFormulario },
        });
    };

    const confirmarEliminacion = (divisionesTiposPropiedades: IDivisionesTiposPropiedades) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarDivisionesTiposPropiedades(divisionesTiposPropiedades),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarDivisionesTiposPropiedades = (divisionesTiposPropiedades: IDivisionesTiposPropiedades) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        divisionesTiposPropiedadesCM.eliminarDivisionesTiposPropiedades(divisionesTiposPropiedades).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <DivisionesTiposPropiedadesVista
            divisionesTiposPropiedadess={divisionesTiposPropiedadess}
            cargarDivisionesTiposPropiedades={cargarDivisionesTiposPropiedades}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableDivisionesTiposPropiedadesCV;
